import { globalTypes } from "reducers/types/global";

export const types = {
    LIST_METROCORP_REQUEST: "metrocorp/LIST_METROCORP_REQUEST",
    LIST_METROCORP_FAILURE: "metrocorp/LIST_METROCORP_FAILURE",
    LIST_METROCORP_SUCCESS: "metrocorp/LIST_METROCORP_SUCCESS",
    LIST_METROCORP_PRE_REQUEST: "metrocorp/LIST_METROCORP_PRE_REQUEST",
    LIST_METROCORP_PRE_FAILURE: "metrocorp/LIST_METROCORP_PRE_FAILURE",
    LIST_METROCORP_PRE_SUCCESS: "metrocorp/LIST_METROCORP_PRE_SUCCESS",
    DOWNLOAD_LIST_METROCORP_REQUEST: "metrocorp/DOWNLOAD_LIST_METROCORP_REQUEST",
    DOWNLOAD_LIST_METROCORP_FAILURE: "metrocorp/DOWNLOAD_LIST_METROCORP_FAILURE",
    DOWNLOAD_LIST_METROCORP_SUCCESS: "metrocorp/DOWNLOAD_LIST_METROCORP_SUCCESS",
    DOWNLOAD_PERFORMANCE_METROCORP_REQUEST: "metrocorp/DOWNLOAD_PERFORMANCE_METROCORP_REQUEST",
    DOWNLOAD_PERFORMANCE_METROCORP_FAILURE: "metrocorp/DOWNLOAD_PERFORMANCE_METROCORP_FAILURE",
    DOWNLOAD_PERFORMANCE_METROCORP_SUCCESS: "metrocorp/DOWNLOAD_PERFORMANCE_METROCORP_SUCCESS",
    DOWNLOAD_DETAIL_METROCORP_REQUEST: "metrocorp/DOWNLOAD_DETAIL_METROCORP_REQUEST",
    DOWNLOAD_DETAIL_METROCORP_FAILURE: "metrocorp/DOWNLOAD_DETAIL_METROCORP_FAILURE",
    DOWNLOAD_DETAIL_METROCORP_SUCCESS: "metrocorp/DOWNLOAD_DETAIL_METROCORP_SUCCESS",
    DOWNLOAD_DETAIL_METROCORP_BY_REFERENCE_REQUEST: "metrocorp/DOWNLOAD_DETAIL_METROCORP_BY_REFERENCE_REQUEST",
    DOWNLOAD_DETAIL_METROCORP_BY_REFERENCE_FAILURE: "metrocorp/DOWNLOAD_DETAIL_METROCORP_BY_REFERENCE_FAILURE",
    DOWNLOAD_DETAIL_METROCORP_BY_REFERENCE_SUCCESS: "metrocorp/DOWNLOAD_DETAIL_METROCORP_BY_REFERENCE_SUCCESS",
    GET_DETAIL_MOVEMENT_REQUEST: "metrocorp/GET_DETAIL_MOVEMENT_REQUEST",
    GET_DETAIL_MOVEMENT_FAILURE: "metrocorp/GET_DETAIL_MOVEMENT_FAILURE",
    GET_DETAIL_MOVEMENT_SUCCESS: "metrocorp/GET_DETAIL_MOVEMENT_SUCCESS",
    FILTER_CHANGE_METROCORP: "metrocorp/FILTER_CHANGE_METROCORP",
    SAVE_OPTION_SELECTED: "metrocorp/SAVE_OPTION_SELECTED",
    DOWNLOAD_REPORT_DRAWER_REQUEST: "metrocorp/DOWNLOAD_REPORT_DRAWER_REQUEST",
    SET_REPORT_DRAWER_VISIBLE: "metrocorp/SET_REPORT_DRAWER_VISIBLE",
    DOWNLOAD_REPORT_DRAWER_FAILURE: "metrocorp/DOWNLOAD_REPORT_DRAWER_FAILURE",
    DOWNLOAD_REPORT_DRAWER_SUCCESS: "metrocorp/DOWNLOAD_REPORT_DRAWER_SUCCESS",
    SET_LOCAL_PAGE: "metrocorp/SET_LOCAL_PAGE",
    UPDATE_FILTERS_DATA: "metrocorp/UPDATE_FILTERS_DATA",
};

export const INITIAL_STATE = {
    fetching: false,
    fetchingList: false,
    fetchingMovementDetail: false,
    fetchingDownload: false,
    fetchingPerformance: false,
    fetchingDetailDownload: false,
    fetchingDetailDownloadByReferenceMobile: undefined,
    clients: [],
    holdings: [],
    dateHoldings: [],
    futureValues: [],
    movements: [],
    fullMovementsList: [],
    fullMovementsListToDownload: [],
    movementsTotalPages: 0,
    localPage: 1,
    futureValuesTotalPages: 0,
    activeTotal: 0.0,
    movementDetail: null,
    filtersData: null,
    filter: {
        filterSelected: "species",
        directionFilter: "ascendent",
    },
    optionSelected: "holdings",
    reportDrawerVisible: false,
    fetchingMonthlyReport: false,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        clients,
        holdings,
        dateHoldings,
        futureValues,
        movements,
        fullMovementsList,
        fullMovementsListToDownload,
        activeTotal,
        movementDetail,
        optionSelected,
        principalAccountClient,
        principalAccount,
        species,
        date,
        dateFrom,
        dateTo,
        page,
        filter,
        downloadReferenceIndex,
        filtersData,
        movementsTotalPages,
        futureValuesTotalPages,
        isDesktop,
        directionFilter,
    } = action;

    switch (action.type) {
        case types.LIST_METROCORP_REQUEST:
            return {
                ...state,
                fetching: true,
                fetchingList: true,
                filtersData: {
                    principalAccountClient,
                    principalAccount,
                    species,
                    date: optionSelected === "holdings" ? date : undefined,
                    dateFrom: optionSelected === "movements" ? dateFrom : undefined,
                    dateTo: optionSelected === "movements" ? dateTo : undefined,
                    page,
                    directionFilter,
                },
            };
        case types.LIST_METROCORP_FAILURE:
            return {
                ...state,
                fetching: false,
                fetchingList: false,
            };
        case types.LIST_METROCORP_SUCCESS:
            return {
                ...state,
                fetching: false,
                fetchingList: false,
                holdings,
                futureValues: isDesktop || page === 1 ? futureValues : [...state.futureValues, ...futureValues],
                movements: isDesktop || page === 1 ? movements : [...state.movements, ...movements],
                fullMovementsList,
                fullMovementsListToDownload,
                dateHoldings,
                movementsTotalPages,
                futureValuesTotalPages,
                localPage: page === 1 ? 1 : state.localPage,
                directionFilter,
            };
        case types.LIST_METROCORP_PRE_REQUEST:
            return {
                ...state,
                fetching: true,
                fetchingList: true,
                fetchingDownload: false,
                fetchingDetailDownload: false,
                fetchingDetailDownloadByReferenceMobile: undefined,
            };
        case types.LIST_METROCORP_PRE_FAILURE:
            return {
                ...state,
                fetching: false,
                fetchingList: false,
            };
        case types.LIST_METROCORP_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                fetchingList: false,
                clients,
                holdings,
                activeTotal,
                filtersData,
                movementsTotalPages,
            };
        case types.DOWNLOAD_LIST_METROCORP_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_LIST_METROCORP_FAILURE:
        case types.DOWNLOAD_LIST_METROCORP_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_PERFORMANCE_METROCORP_REQUEST:
            return {
                ...state,
                fetchingPerformance: true,
            };
        case types.DOWNLOAD_PERFORMANCE_METROCORP_FAILURE:
        case types.DOWNLOAD_PERFORMANCE_METROCORP_SUCCESS:
            return {
                ...state,
                fetchingPerformance: false,
            };
        case types.GET_DETAIL_MOVEMENT_REQUEST:
            return {
                ...state,
                fetchingMovementDetail: true,
            };
        case types.GET_DETAIL_MOVEMENT_FAILURE:
            return {
                ...state,
                fetchingMovementDetail: false,
            };
        case types.GET_DETAIL_MOVEMENT_SUCCESS:
            return {
                ...state,
                fetchingMovementDetail: false,
                movementDetail,
            };
        case types.DOWNLOAD_DETAIL_METROCORP_REQUEST:
            return {
                ...state,
                fetchingDetailDownload: true,
            };
        case types.DOWNLOAD_DETAIL_METROCORP_FAILURE:
        case types.DOWNLOAD_DETAIL_METROCORP_SUCCESS:
            return {
                ...state,
                fetchingDetailDownload: false,
            };
        case types.DOWNLOAD_DETAIL_METROCORP_BY_REFERENCE_REQUEST:
            return {
                ...state,
                fetchingDetailDownloadByReferenceMobile: downloadReferenceIndex,
            };
        case types.DOWNLOAD_DETAIL_METROCORP_BY_REFERENCE_FAILURE:
        case types.DOWNLOAD_DETAIL_METROCORP_BY_REFERENCE_SUCCESS:
            return {
                ...state,
                fetchingDetailDownloadByReferenceMobile: undefined,
            };
        case types.FILTER_CHANGE_METROCORP:
            return {
                ...state,
                filter: {
                    filterSelected: filter.filterSelected,
                    directionFilter: filter.directionFilter === "ascendent" ? "descendent" : "ascendent",
                },
                futureValues: futureValues.sort((a, b) => (filter.directionFilter === "ascendent" ? a - b : b - a)),
            };
        case types.SAVE_OPTION_SELECTED:
            return {
                ...state,
                optionSelected,
                filtersData: {
                    principalAccountClient,
                    principalAccount,
                    species,
                    date: optionSelected === "holdings" ? date : undefined,
                    dateFrom: optionSelected === "movements" ? dateFrom : undefined,
                    dateTo: optionSelected === "movements" ? dateTo : undefined,
                    page,
                },
                holdings: [],
                futureValues: [],
                movements: [],
                fullMovementsList: [],
                fullMovementsListToDownload: [],
                localPage: 1,
            };
        case types.SET_LOCAL_PAGE:
            return {
                ...state,
                localPage: action.localPage,
            };
        case types.UPDATE_FILTERS_DATA:
            return {
                ...state,
                filtersData: {
                    ...state.filtersData,
                    ...action.filtersData,
                },
            };
        case types.SET_REPORT_DRAWER_VISIBLE:
            return {
                ...state,
                reportDrawerVisible: action.reportDrawerVisible,
            };
        case types.DOWNLOAD_REPORT_DRAWER_REQUEST:
            return {
                ...state,
                fetchingMonthlyReport: true,
            };

        case types.DOWNLOAD_REPORT_DRAWER_SUCCESS:
        case types.DOWNLOAD_REPORT_DRAWER_FAILURE:
            return {
                ...state,
                fetchingMonthlyReport: false,
            };

        case globalTypes.RESET_SELECTED_ELEMENTS:
        case globalTypes.CLEAN_UP:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export const actions = {
    listMetrocorpPre: () => ({
        type: types.LIST_METROCORP_PRE_REQUEST,
    }),
    listMetrocorp: (
        optionSelected,
        principalAccountClient,
        principalAccount,
        species,
        date,
        dateFrom,
        dateTo,
        page,
        isDesktop,
        directionFilter,
    ) => ({
        type: types.LIST_METROCORP_REQUEST,
        optionSelected,
        principalAccountClient,
        principalAccount,
        species,
        date,
        dateFrom,
        dateTo,
        page,
        isDesktop,
        directionFilter,
    }),
    downloadMetrocorpList: (summary, format) => ({
        type: types.DOWNLOAD_LIST_METROCORP_REQUEST,
        summary,
        format,
    }),
    downloadMetrocorpPerformance: (account, date, verifyCode) => ({
        type: types.DOWNLOAD_PERFORMANCE_METROCORP_REQUEST,
        account,
        date,
        verifyCode,
    }),
    getMovementDetail: (reference, codEspe, nombre, apellido, currency, observaciones) => ({
        type: types.GET_DETAIL_MOVEMENT_REQUEST,
        reference,
        codEspe,
        nombre,
        apellido,
        currency,
        observaciones,
    }),
    downloadMetrocorpDetail: (detail, format, onClose) => ({
        type: types.DOWNLOAD_DETAIL_METROCORP_REQUEST,
        detail,
        format,
        onClose,
    }),
    downloadMetrocorpDetailByReference: (
        downloadReferenceIndex,
        reference,
        codEspe,
        nombre,
        apellido,
        currency,
        format,
        observaciones,
    ) => ({
        type: types.DOWNLOAD_DETAIL_METROCORP_BY_REFERENCE_REQUEST,
        downloadReferenceIndex,
        reference,
        codEspe,
        nombre,
        apellido,
        currency,
        format,
        observaciones,
    }),
    changeFilter: (futureValues, filter) => ({
        type: types.FILTER_CHANGE_METROCORP,
        futureValues,
        filter,
    }),
    saveOptionSelected: (
        optionSelected,
        principalAccountClient,
        principalAccount,
        species,
        date,
        dateFrom,
        dateTo,
    ) => ({
        type: types.SAVE_OPTION_SELECTED,
        optionSelected,
        principalAccountClient,
        principalAccount,
        species,
        date,
        dateFrom,
        dateTo,
    }),
    setReportsDrawerVisible: (reportDrawerVisible) => ({
        type: types.SET_REPORT_DRAWER_VISIBLE,
        reportDrawerVisible,
    }),
    downloadMonthlyReport: (reportDrawerValues) => ({
        type: types.DOWNLOAD_REPORT_DRAWER_REQUEST,
        reportDrawerValues,
    }),
    setLocalPage: (localPage) => ({
        type: types.SET_LOCAL_PAGE,
        localPage,
    }),
    updateFiltersData: (filtersData) => ({
        type: types.UPDATE_FILTERS_DATA,
        filtersData,
    }),
};

export const selectors = {
    getFetching: ({ metrocorp }) => metrocorp.fetchingList,
    getFetchingList: ({ metrocorp }) => metrocorp.fetchingList,
    getFetchingMovementDetail: ({ metrocorp }) => metrocorp.fetchingMovementDetail,
    getFetchingDownload: ({ metrocorp }) => metrocorp.fetchingDownload,
    getFetchingPerformance: ({ metrocorp }) => metrocorp.fetchingPerformance,
    getClients: ({ metrocorp }) => metrocorp.clients,
    getHoldings: ({ metrocorp }) => metrocorp.holdings,
    getDateHoldings: ({ metrocorp }) => metrocorp.dateHoldings,
    getFutureValues: ({ metrocorp }) => metrocorp.futureValues,
    getMovements: ({ metrocorp }) => metrocorp.movements,
    getFullMovementsList: ({ metrocorp }) => metrocorp.fullMovementsList,
    getFullMovementsListToDownload: ({ metrocorp }) => metrocorp.fullMovementsListToDownload,
    getActiveTotal: ({ metrocorp }) => metrocorp.activeTotal,
    getMovementDetail: ({ metrocorp }) => metrocorp.movementDetail,
    getFiltersData: ({ metrocorp }) => metrocorp.filtersData,
    getMovementsTotalPages: ({ metrocorp }) => metrocorp.movementsTotalPages,
    getFutureValuesTotalPages: ({ metrocorp }) => metrocorp.futureValuesTotalPages,
    getFilter: ({ metrocorp }) => metrocorp.filter,
    getFetchingDetailDownload: ({ metrocorp }) => metrocorp.fetchingDetailDownload,
    getFetchingDetailDownloadByReferenceMobile: ({ metrocorp }) => metrocorp.fetchingDetailDownloadByReferenceMobile,
    getOptionSelected: ({ metrocorp }) => metrocorp.optionSelected,
    isReportDrawerVisible: ({ metrocorp }) => metrocorp.reportDrawerVisible,
    getFetchingMonthlyReport: ({ metrocorp }) => metrocorp.fetchingMonthlyReport,
    getLocalPage: ({ metrocorp }) => metrocorp.localPage || 1,
};
